export const convertToTableData = (data) => {
  // Check if data.results exists and is an array
  if (!Array.isArray(data?.results)) {
    return [];
  }

  return data?.results?.map((item) => {
    const semesterData = [item.json?.table] || [];
    const semester = item?.semester;

    return {
      id: item.id,
      semester: semester,
      semester_name: `Semester ${semester}`,
      apa_point: item?.apa_point,
      status: item.status,
      comment: item.comment,
      data: semesterData.map((course, index) => ({
        key: course.id || index,
        number_of_sessions: course.number_of_sessions || 0,
        modal: course.modal || [],
      })),
    };
  });
};


  

  export const convertToRequestData = (planning, selectedYear, formId, semester) => {
    const semesterPlan = planning.find((plan) => plan.semester === semester);
    if (!semesterPlan) {
      return null;
    }

    const tableData = semesterPlan?.courses?.map((course, index) => ({
      key: course.id || index,
      number_of_sessions: course.number_of_sessions || 0,
      modal: course.modal || [],
   
    }))


    
    return {
      apa_form: formId,
      year: selectedYear,
      semester: semester,
      apa_point: semesterPlan.apa_point || 0,
      json: {
        table: tableData[0],
      },
    };
  };
  
  

  export const convertPlanningToRequestData = (planningData, year, apa_form) => {
    return planningData.map((plan) => {
      const tableData = {
        number_of_sessions: plan.number_of_sessions?.count || 0,
        modal: plan.modal || [],
      };
  
      return {
        apa_form: apa_form,
        year: year,
        semester: plan.semester,
        apa_point: plan.apa_point || 0,
        json: {
          table: tableData,
        },
      };
    });
  };
  